export const RUSSIAN_PHONE_PLACEHOLDER = '+7 xxx-xxx-xx-xx';
export const RUSSIAN_PHONE_PATTERN = '\\+7 [0-9]{3}-[0-9]{3}-[0-9]{2}-[0-9]{2}';

export function russianPhoneDigits(value) {
  const raw = String(value ?? '');
  let digits = raw.replace(/\D/g, '');
  const hasExplicitRussianPrefix = /^\s*\+7/.test(raw);

  if (hasExplicitRussianPrefix || (digits.length === 11 && ['7', '8'].includes(digits[0]))) {
    digits = digits.slice(1);
  }

  return digits.slice(0, 10);
}

export function formatRussianPhone(value, { showPrefixForEmpty = false } = {}) {
  const raw = String(value ?? '');
  const digits = russianPhoneDigits(raw);
  if (!digits) {
    return showPrefixForEmpty || /^\s*\+7/.test(raw) ? '+7 ' : '';
  }

  let formatted = `+7 ${digits.slice(0, 3)}`;
  if (digits.length > 3) formatted += `-${digits.slice(3, 6)}`;
  if (digits.length > 6) formatted += `-${digits.slice(6, 8)}`;
  if (digits.length > 8) formatted += `-${digits.slice(8, 10)}`;
  return formatted;
}

export function isCompleteRussianPhone(value) {
  return russianPhoneDigits(value).length === 10;
}
